import React, { useContext, useEffect, useState } from 'react'
import Modal from 'react-responsive-modal'
import styles from './styles.module.scss'
import { IoIosClose } from "react-icons/io";
import { load } from '../../../img/svg'
import { useDispatch, useSelector } from 'react-redux';
import { getFile, getRecordsList, getTranscritionsList } from '../../../actions/main';
import { MainContext } from '../../../utils/context';
import { FaPhotoVideo } from "react-icons/fa";
import moment from 'moment';


const Resume = () => {
  
  const dispatch = useDispatch()
  const { records, transcriptions } = useSelector(state => state.main)
  const { roomName, room } = useContext(MainContext)
  
  const [open, setOpen] = useState(false)
  const [first, setFirst] = useState(true)

  useEffect(() => {
    if (room) return;
    dispatch(getRecordsList(roomName, false))
    dispatch(getTranscritionsList(roomName))
    !first && setOpen(true)
    setFirst(false)
  }, [room])


  const onClose = () => setOpen(false)

  const loadFileHandler = (mode) => () => {
    dispatch(getFile(roomName, mode))
  }

  const { date, duration, participants } = records[0] || {}

  return (
    <>
      {records[0] &&
        <FaPhotoVideo
          size={30}
          onClick={() => setOpen(true)}
          className={styles.icon}
        />
      }
      <Modal
        open={open}
        onClose={onClose}
        classNames={{
          modal: styles.modal,
          overlay: styles.overlay
        }}
        closeOnEsc={false}
        closeOnOverlayClick={false}
        showCloseIcon={false}
      >
        <h1>Конференция завершена</h1>
        
        {records[0] &&
          <div>
          <p>{roomName}</p>
          <p>{moment(date).format('DD.MM.YYYY')}</p>
          <p>Участников: {participants + 1}</p>
          <p>Длительность: {moment.utc(duration/1000_000).format('HH:mm:ss')}</p>
        </div>}

        <IoIosClose color='white' size={60} onClick={onClose}/>

        <div>
          <button
            disabled={!transcriptions[0]}
            onClick={loadFileHandler('resume')}
            >
            {load} Скачать краткий пересказ
          </button>
          
          <button
            disabled={!transcriptions[0]}
            onClick={loadFileHandler('transcription')}
            >
              {load} Скачать полный пересказ
          </button>

          <button
            disabled={!records[0]}
            onClick={loadFileHandler('record')}
          >
            {load}
            <p>Скачать видеозапись</p>
          </button>
        </div>

      </Modal>
    </>
  )
}

export default Resume